/* eslint-disable import/group-exports */

export interface AppStoreLinks {
  apple: string
  android: string
}

interface AppStores {
  [key: string]: AppStoreLinks
}

export const appStoreTrackingNames: AppStoreLinks = {
  apple: 'apple app store',
  android: 'google play',
}

export const appStores: AppStores = {
  GBR: {
    apple:
      'https://itunes.apple.com/gb/app/babylon-health-doctor-consultations/id858558101?mt=8',
    android:
      'https://play.google.com/store/apps/details?id=com.babylon&hl=en_GB', // It can't be changed to 'google' because of old tracking consistency
  },
  USA: {
    apple:
      'https://apps.apple.com/us/app/babylon-healthcheck-chatbot/id1455221792',
    android: 'https://play.google.com/store/apps/details?id=com.babylon.us',
  },
}

export const babylonWebsiteUrl = 'https://www.babylonhealth.com'
export const WEB_APP_URL = '{webAppUrl}'
